export function inViewport(element : HTMLElement) {
    var elH = element.offsetHeight,
        H   = window.innerHeight,
        r   = element.getBoundingClientRect(), t=r.top, b=r.bottom;
    return Math.max(0, t>0? Math.min(elH, H-t) : Math.min(b, H));
}

document.addEventListener('DOMContentLoaded', function () {
    const ai = (window as any).appInsights;

    const cookiebot = (window as any).Cookiebot;
    if (!cookiebot?.consent?.statistics) {
        if (typeof ai === 'object' && typeof ai.config === 'object') {
            ai.config.disableCookiesUsage = true;
        }

    }

    // Släpp browser-genererad Fetch/Ajax-dependency-telemetri mot vår egen sajt.
    // Detta är den telemetri som driver Application Insights daily ingestion i taket.
    if (ai && typeof ai.addTelemetryInitializer === 'function') {
        ai.addTelemetryInitializer((envelope: any) => {
            if (envelope?.baseType === 'RemoteDependencyData') {
                const type = envelope?.baseData?.type;
                if (type === 'Fetch' || type === 'Ajax') {
                    return false; // droppa – skickas aldrig till Application Insights
                }
            }
            return true;
        });
    }
});
window.addEventListener('load', function () {
    const cookiebot = (window as any).Cookiebot;
    if (!cookiebot?.consent?.statistics) {
        ['ai_session', 'ai_user'].forEach(name => {
            if (document.cookie.split(';').some(c => c.trim().startsWith(name + '='))) {
                document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
            }
        });
    }
});